import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { toggleIsLoading } from '../../store/modules/interfaces/actions';

export const PageLoader = styled.div`
  background-color: ${(props) => props.theme.color.background};
  bottom: 0;
  left: 0;
  opacity: 0.75;
  pointer-events: none;
  position: fixed;
  right: 0;
  top: 0;
  visibility: visible;
  z-index: ${(props) => props.theme.layers.balcony};

  ${(props) => props.theme.loader()}
`;

// TODO: do we use the isPageLoading state? or is this deprecated?
const withPLP = (PLP) => {
  const Component = (props) => (
    <>
      {props.isPageLoading && <PageLoader />}
      <PLP {...props} />
    </>
  );

  Component.defaultProps = {
    isPageLoading: true
  };

  Component.propTypes = {
    isPageLoading: PropTypes.bool
  };

  return connect((state) => ({
    isPageLoading: state.interfaces.isLoading
  }), (dispatch) => ({
    toggleIsPageLoading: (loading) => dispatch(toggleIsLoading(loading))
  }))(Component);
};

export default withPLP;
